// 组件类
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  ElementRef,
  HostListener,
  ChangeDetectorRef,
  AfterViewInit,
} from "@angular/core";
import { StepItem, StepperOrientation } from "./constants";
import { CommonFunctionService } from "../../service/common-function.service";

@Component({
  selector: "rs-stepper",
  templateUrl: "./index.component.html",
  styleUrls: ["./index.component.scss"],
})
export class RSStepperComponent implements OnInit, AfterViewInit {
  @ViewChild("menu", { static: false }) menu!: ElementRef;
  @Input() steps: StepItem[] = [];
  @Input() currentStep: number = 0;
  /** Layout direction: 'horizontal' (default) or 'vertical' */
  @Input() orientation: StepperOrientation = "horizontal";
  constructor(
    public cf: CommonFunctionService,
    private ref: ChangeDetectorRef
  ) {}
  @Output() stepClick = new EventEmitter<StepItem>();
  @Input() unlockedStep: number = 0; //已解锁的最大步骤
  @Input() containerRefId;

  ngOnInit() {
    this.steps.forEach((step) => {
      step.displayTitle = this.cf.setMiddleEllipsis(step.label, 132, 12);
    });
    this.syncUnlockedStep();
  }

  ngAfterViewInit() {
    if (this.orientation === "horizontal") {
      setTimeout(() => this.checkBtnShow(true));
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["currentStep"] && !changes["currentStep"].firstChange) {
      this.syncUnlockedStep();
      if (this.orientation === "horizontal") {
        setTimeout(() => this.scrollToStep());
      }
    }
    if (
      this.orientation === "horizontal" &&
      ((changes["steps"] && changes["steps"].currentValue) ||
        changes["currentStep"])
    ) {
      setTimeout(() => this.checkBtnShow());
    }
  }

  // 同步unlockedStep的最大值
  private syncUnlockedStep() {
    if (this.currentStep > this.unlockedStep) {
      this.unlockedStep = this.currentStep;
    }
  }

  onStepClick(step: StepItem, index?: number) {
    if (step.step <= this.unlockedStep) {
      this.currentStep = step.step;
      this.stepClick.emit(step);
      if (this.orientation === "horizontal") {
        setTimeout(() => this.scrollToStep(index));
      }
    }
  }

  private scrollToStep(index?: number) {
    if (!this.menu || !this.menu.nativeElement) return;

    const menuEl = this.menu.nativeElement;
    const items = menuEl.querySelectorAll(".step");
    const targetIndex =
      typeof index === "number"
        ? index
        : this.steps.findIndex((s) => s.step === this.currentStep);

    if (targetIndex < 0 || targetIndex >= items.length) return;

    const targetEl = items[targetIndex] as HTMLElement;

    //获取相对位置
    const containerRect = menuEl.getBoundingClientRect();
    const elementRect = targetEl.getBoundingClientRect();

    // 计算元素相对于容器的位置
    const elementRelativeLeft =
      elementRect.left - containerRect.left + menuEl.scrollLeft;
    const elementWidth = elementRect.width;
    const containerWidth = menuEl.clientWidth;

    // 计算元素中心点相对于容器的位置
    const elementCenter = elementRelativeLeft + elementWidth / 2;

    // 目标滚动位置：让元素中心出现在可视区域中心
    const scrollTarget = elementCenter - containerWidth / 2;

    // 限制在有效滚动范围内
    const maxScroll = Math.max(0, menuEl.scrollWidth - containerWidth);
    const finalTarget = Math.max(0, Math.min(scrollTarget, maxScroll));

    menuEl.scrollTo({ left: finalTarget, behavior: "smooth" });
    this.onScroll();
  }

  @HostListener("window:resize", ["$event"])
  onResize(_event: Event) {
    if (this.orientation === "horizontal") {
      this.checkBtnShow();
    }
  }

  checkBtnShow(init?: boolean) {
    if (!this.menu || !this.menu.nativeElement) return;

    const menuEl = this.menu.nativeElement;
    const { scrollWidth, clientWidth } = menuEl;

    // 判断是否需要显示滚动按钮
    let threshold = clientWidth;
    if (this.containerRefId) {
      const containerRef = document.getElementById(this.containerRefId);
      if (containerRef) {
        threshold = Math.max(containerRef.offsetWidth * 0.8, 400);
      }
    }

    this.showBtn = scrollWidth > threshold;

    // 初始化时滚动到当前步骤
    if (init) {
      setTimeout(() => this.scrollToStep(), 0);
    }

    this.onScroll();
    this.ref.markForCheck();
  }
  scrollLeft() {
    const { scrollLeft } = this.menu.nativeElement;
    const dis = scrollLeft / 100 < 2 ? scrollLeft + 10 : 100;
    this.menu.nativeElement.scrollBy({ left: -dis, behavior: "smooth" });
  }
  scrollRight() {
    const { scrollLeft, scrollWidth, clientWidth } = this.menu.nativeElement;
    const rest = scrollWidth - clientWidth - scrollLeft;
    const dis = rest / 100 < 2 ? rest + 10 : 100;
    this.menu.nativeElement.scrollBy({ left: dis, behavior: "smooth" });
  }

  showBtn = false;
  isAtStart = true;
  isAtEnd = false;
  onScroll() {
    const { scrollLeft, scrollWidth, clientWidth } = this.menu.nativeElement;
    this.isAtStart = scrollLeft <= 1;
    this.isAtEnd = scrollLeft + clientWidth >= scrollWidth - 1;
    this.ref.markForCheck();
  }
}
